import { render, staticRenderFns } from "./RePresentaionMyObjButton.vue?vue&type=template&id=1d3b735a&scoped=true"
import script from "./RePresentaionMyObjButton.vue?vue&type=script&lang=js"
export * from "./RePresentaionMyObjButton.vue?vue&type=script&lang=js"
import style0 from "./RePresentaionMyObjButton.vue?vue&type=style&index=0&id=1d3b735a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b735a",
  null
  
)

export default component.exports